export default class UseConsumeStatus {

    static INCLUDED = new UseConsumeStatus(1, 'Aguardando aprovação')
  
    static APPROVED = new UseConsumeStatus(2, 'Em processo de faturamento')
  
    static DISAPPROVED = new UseConsumeStatus(3, 'Solicitação não aprovada')
  
    static BILLING = new UseConsumeStatus(4, 'Faturado')
  
    static BILLING_FAIL = new UseConsumeStatus(5, 'Falha no faturamento')
  
    static EXPIRED = new UseConsumeStatus(6, 'Solicitação expirada')
  
    static PENDING_VERIFICATION = new UseConsumeStatus(7, 'Pendente de verificação')
  
    static allStatus() {
      return [
        UseConsumeStatus.INCLUDED,
        UseConsumeStatus.APPROVED,
        UseConsumeStatus.DISAPPROVED,
        UseConsumeStatus.BILLING,
        UseConsumeStatus.BILLING_FAIL,
        UseConsumeStatus.EXPIRED,
        UseConsumeStatus.PENDING_VERIFICATION,
      ]
    }
  
    constructor(value, label) {
      this.value = value
      this.label = label
    }
  }